// https://github.com/biati-digital/glightbox
import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';



const lightbox = GLightbox({
    touchNavigation: false,
    touchFollowAxis: false,
    keyboardNavigation: false,
    zoomable: false,
    draggable: false,
});


$( document ).ready(function() {

    const sharebox = GLightbox({
        skin: "sharebox",
        selector: ".glightbox-share",
        touchNavigation: false,
        touchFollowAxis: false,
        keyboardNavigation: false,
        zoomable: false,
        draggable: false,
        // width: '60vw',
        height: 'auto'
    });

    // $('.close-popup').click(function(e){
    //     e.preventDefault();
    //     console.log("close popup");
    //     sharebox.close();
    // })

        sharebox.on('open', () => {
            $('.close-popup').click(function(){
                sharebox.close();
            })
      });

      const searchbox = GLightbox({
          /*touchNavigation: false,
          touchFollowAxis: false,
          keyboardNavigation: false,*/
          selector: ".searchboxlink",
          zoomable: false,
          draggable: false,
          // width: '60vw',
          height: 'auto'
      });
});
